module.exports = __webpack_public_path__ + "static/familyongrasscalculator-3aaba3fe1ed9c0c32416dab55db8af68.png";